<template>
    <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
      <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
        <v-row class="m-0 mb-1 elevation-1" style="max-height: 2.55rem; ">
          <v-col sm="3" md="2" xl="2" class="p-0">
            <v-row class="m-0" style="height: 2.55rem; margin-left: auto !important; margin-right: auto !important; width: 250px;">
              <button  type="button" :class="{
              'v-icon': true,
              'large': true,
              'notranslate': true,
               'v-data-table__expand-icon': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-chevron-left': true,
                   'theme--light': true,}" style="height: 32px; width: 32px; font-size: 36px;
                    margin-top: auto;
                     margin-bottom: auto;" @click="moveDate(-1)"></button>


              <datetime
                  style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-left: 6px; margin-right: 6px; margin-top: auto;
                     margin-bottom: auto; width: 150px;"
                  v-model="date"
                  input-class="form-control text-center"
                  input-style="color: black;"
                  input-id="date"
                  :phrases="datetimeConfig.phrases"
                  :format="{  month: 'long', day: '2-digit' }"
                  @input="setDate"></datetime>
              <button  type="button" :class="{
              'v-icon': true,
              'large': true,
              'notranslate': true,
               'v-data-table__expand-icon': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-chevron-right': true,
                   'theme--light': true,}" style="height: 32px; width: 32px; font-size: 36px;
                    margin-top: auto;
                     margin-bottom: auto;" @click="moveDate(1)"></button>
            </v-row>
          </v-col>
          <v-col class="p-0">
            <v-row class="m-0" style="height: 2.55rem">
        <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Zeiterfassung: {{selectedMitaName}}</span>
              <v-chip v-if="overview.rb"
                  style="margin-left: auto;
            margin-right: 12px;
            margin-top: auto;
            margin-bottom: auto;"

                  :class="{'soll-ist': true, 'zero': true, 'hidden': overview.rb === ''}"
              >
                <strong>RB: {{overview.rb}}</strong>
              </v-chip>
              <v-chip
                  style="
            margin-right: 12px;
            margin-top: auto;
            margin-bottom: auto;"
                  :style="{'margin-left': overview.rb ? '8px' : 'auto',
                  'background-color': currentMita ? '' : 'white !important'}"

                  :class="{'soll-ist': true, 'neg': overview.user_day.soll > overview.user_day.ist, 'pos': overview.user_day.soll <= overview.user_day.ist}"
              >
                <strong>Soll: {{formateHours(overview.user_day.soll)}}&nbsp;&nbsp;|&nbsp;&nbsp;Ist: {{formateHours(overview.user_day.ist)}}</strong>
              </v-chip>
              <b-button variant="primary"
                        class="btn-pill font-lg ml-2"
                        style="color: white; padding: 0.2rem 0.5rem; height: 2rem; margin-top: 4px; margin-right: 8px"
                        v-on:click="onBack">
                &nbsp;Zurück
              </b-button>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="m-0">
          <v-col sm="3" md="2" xl="2" style="padding-bottom: 0px">
            <v-select
                v-model="mita_select_value"
                :items="mita_select"
                filled
                hide-details
                label="Darstellungsart"
            ></v-select>
            <v-text-field v-if="mita_select_value !== 'Mitarbeitergruppen'" class="mt-1" prepend-inner-icon="mdi-magnify" hide-details single-line filled label="Suchen" v-model="search" clearable @click:clear="clearSearch"></v-text-field>
            <v-list v-if="mita_select_value === 'Mitarbeitergruppen'" style="max-height: calc(100vh - 55px - 72px - 56px); overflow-y: auto">
              <v-list-group
                  v-for="(migr, j) in migrs"
                  :key="j">
                <template v-slot:activator>
                  <v-list-item-title v-text="migr"></v-list-item-title>
                </template>
                <v-list-item-group
                    v-model="currentMita"
                    @change="changeMita">
                  <v-list-item
                      v-for="(mita, i) in sortedItems(migr)"
                      :key="mita.id"
                      :value="mita.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="mita.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list-group>
            </v-list>
            <v-list v-else style="max-height: calc(100vh - 55px - 72px - 56px - 56px); overflow-y: auto">
              <v-list-item-group
                  v-model="currentMita"
                  color="primary"
                  @change="changeMita"
              >
                <v-list-item
                    v-for="(mita, i) in filteredItems"
                    :key="mita.id"
                    :value="mita.id"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="mita.name" :style="{color: getUserColor(mita)}"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action v-if="isMobile(mita)">
                    <v-list-item-action-text v-text="'M'"></v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col class="fill-height">
            <v-row class="fill-height">
              <v-col cols="3" class="fill-height">
              <day-view
                  ref="day_view"
                  :date="date"
                  :current-mita="currentMita"
                  :mitas-flat="mitasFlat"
                  :overview="overview"
                  :holiday-lohn="''"
                  :focused-event="currentExpand"
                  @click-event="onExpand($event, false)"
                  @create-time-block="onNewTime"
                  @extend-time-block="onExtendTimeBlock"
              > </day-view>
              </v-col>
              <v-col  cols="6" class="fill-height">
                <v-data-table
                    dense
                    :headers="userDayHeaders"
                    :items="overview.time_blocks"
                    style="margin-top: 3px"
                    height="calc(100vh - 95px - 2.55rem - 4px - 56px - 36px)"
                    hide-default-footer
                    disable-pagination
                    item-key="id"
                    single-expand
                    show-expand
                    fixed-header
                    no-data-text="Keine Daten vorhanden."
                    ref="user_day_table"
                    :item-class="getItemClass"
                    @click:row="onExpand"
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <v-row v-for="child in item.children" :key="child.id" class="m-0">
                        <v-col md="1" class="p-1"></v-col>
                        <v-col class="p-1"  md="1">
                          <v-icon aria-label="Typ" role="img" aria-hidden="false"
                          >
                            {{child.type === 'FAGE' ? 'mdi-car' : child.type === 'LOHN' ? 'mdi-cash' : 'mdi-toolbox'}}
                          </v-icon>
                        </v-col>
                        <v-col class="p-1">
                          {{child.type === 'ARTI' ? 'Menge: ' + child.std : 'Dauer: ' + child.std + ' Std.'}}
                        </v-col>
                        <v-col class="p-1">
                          {{child.title}}
                        </v-col>
                      </v-row>
                    </td>
                  </template>
                  <template v-slot:item.hinweis="{ item }">
                    <button v-if="item.hinweis !== ''" type="button" :class="{
              'v-icon': true,
              'notranslate': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-information': true,
                   'theme--light': true}" @click="showHint(item)"></button>
                  </template>
                  <template v-slot:item.data-table-expand="{ item }">
                    <button v-if="item.children !== null && item.children.length" type="button" :class="{
              'v-icon': true,
              'notranslate': true,
               'v-data-table__expand-icon': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-chevron-down': true,
                   'theme--light': true,
                  'v-data-table__expand-icon--active': currentExpand === item.id}" @click.stop="onExpand(item)"></button>
                  </template>
                </v-data-table>

              </v-col>
              <v-col cols="3" class="fill-height" style="padding-top: 0px; padding-right: 0px">
                <v-card
                    style="width: 100%; height: calc(100vh - 115px);" class="overflow-y-auto overflow-x-hidden">
                  <v-row style="padding: 6px" v-if="currentBlock === -1 && currentMita">
                    <v-col style="padding-bottom: 0px">
                    <v-btn
                        block
                        tile
                        color="warning"
                        style="height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                        :disabled="overview.user_day.ist >= overview.user_day.soll"
                        @click="onBookAbfeiern"
                    >
                      <v-icon left>
                        mdi-account-clock
                      </v-icon>
                      Abfeiern
                    </v-btn>
                    </v-col>
                    <v-col style="padding-bottom: 0px">
                    <v-btn
                        block
                        tile
                        color="warning"
                        style="height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                        :disabled="overview.user_day.ist >= overview.user_day.soll"
                        @click="$refs.fehlDialog.openDialog()"
                    >
                      <v-icon left>
                        mdi-account-cancel
                      </v-icon>
                      Fehlzeiten
                    </v-btn>
                    </v-col>
                    <v-col style="padding-bottom: 0px">
                      <v-btn
                          block
                          tile
                          color="success"
                          style="height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                          @click="onNewTime({start: '', end: ''})"
                      >
                        <v-icon left>
                          mdi-plus
                        </v-icon>
                        Hinzufügen
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row style="padding: 6px" v-else-if="currentMita">
                    <v-col style="padding-bottom: 0px">
                    <v-btn
                        block
                        tile
                        color="error"
                        style="height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                        @click="onDelete"
                    >
                      <v-icon left>
                        mdi-delete
                      </v-icon>
                      Löschen
                    </v-btn>
                    </v-col>
                    <v-col style="padding-bottom: 0px">
                      <v-btn
                          block
                          tile
                          color="success"
                          style="height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                          @click="openExisting"
                      >
                        <v-icon left>
                          mdi-pencil
                        </v-icon>
                        Anpassen
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="padding-top: 0px; padding-bottom: 0px">
                      <v-divider style="margin: 0; margin-top: 2px"></v-divider>
                      <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px; margin-top: 6px">
                        Zulagen
                      </v-card-title>
                      <v-divider style="margin: 0"></v-divider>
                      <v-data-table
                          :headers="headers_surcharges"
                          :items="items_surcharges"
                          hide-default-footer
                          disable-pagination
                          disable-sort
                          style="max-height: 22vh; min-height: 22vh; overflow-y: auto"
                      ></v-data-table>
                      <v-divider style="margin: 0"></v-divider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="padding-top: 0px; padding-bottom: 0px">
                      <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px">
                        Fahrzeuge und Geräte
                      </v-card-title>
                      <v-divider style="margin: 0"></v-divider>
                      <v-data-table
                          :headers="headers_fahrs"
                          :items="items_fahrs"
                          hide-default-footer
                          disable-pagination
                          disable-sort
                          style="max-height: 21vh; min-height: 21vh; overflow-y: auto"
                      ></v-data-table>
                      <v-divider style="margin: 0"></v-divider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="padding-top: 0px; padding-bottom: 0px">
                      <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px">
                        Material
                      </v-card-title>
                      <v-divider style="margin: 0"></v-divider>
                      <v-data-table
                          :headers="headers_artis"
                          :items="items_artis"
                          hide-default-footer
                          disable-pagination
                          disable-sort
                          style="max-height: 21vh; min-height: 21vh; overflow-y: auto"
                      ></v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-overlay
                absolute
                :value="false"
                style="margin: 12px"
                opacity="0.1"
            >
              <v-row>
                <v-col>
                </v-col>
              </v-row>
            </v-overlay>
          </v-col>
        </v-row>

      </div>
      <fehl-dialog ref="fehlDialog"
                   :fehls="fehls"
      @selected-fehl="onFehlSelected"/>
      <time-block-dialog ref="timeBlockDialog"
                         :current-mita="currentMitaValue"
                         :blocked-intervals="blockedIntervals"
                         :breaks="breaks"
                         :start="createStart"
                         :end="createEnd"
                         :time-block="editBlock"
                         :time-block-surcharges="timeBlockSurcharges"
                         :show-loader="showLoader"
                         :hide-loader="hideLoader"
                         :augrs="augrs"
                         :object-map="objectMap"
                         :legrs="legrs"
                         :lear-map="learMap"
                         :fehls="fehls"
                         :artis="artis"
                         :surcharges="ezs"
                         :fahrs="fahrs"
                         :schluessel-mapping="schluessel_mapping"
                         :einzel-mapping="einzelMapping"
                         :special-car-module="specialCarModule"
                         @save-block="saveBlock"
      />
    </v-main>
</template>

<script>

import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy"
import _throttle from "lodash/throttle"
import {getUid} from "@/shared/crypto";
import DayView  from "@/views/zeitkontrolle/DayView.vue";
import TimeBlockDialog  from "@/views/zeitkontrolle/TimeBlockDialog.vue";
import FehlDialog  from "@/views/zeitkontrolle/SelectFehlDialog.vue";
import AuskunftMonth from "@/views/calendar/AuskunftMonth.vue";


export default {
  name: "UserDay",
  components: {
    DayView,
    TimeBlockDialog,
    FehlDialog
  },
  data: () => ({
    mita_select: ['Mitarbeitergruppen', 'Mitarbeiter'],
    mita_select_value: 'Mitarbeiter',
    currentMode: "day",
    focus: '',
    migrs: [],
    mitas: [],
    mitasFlat: [],
    activeMita:[],
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    currentMonth: 0,
    currentYear: 0,
    overlay: true,
    currentMita: undefined,
    datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}},

    userDayHeaders: [
      {
        text: 'Von',
        value: 'von',
        sortable: false,
      },
      {
        text: 'Bis',
        value: 'bis',
        sortable: false,
      },
      {
        text: 'Std',
        value: 'std',
        sortable: false,
      },
      { text: 'Titel', value: 'task', sortable: false, },
      { text: 'Leistung', value: 'legr', sortable: false, },
      { text: 'Hinweis', value: 'hinweis', sortable: false, },
      { text: '', value: 'data-table-expand' },
    ],
    time_blocks: [],
    currentExpand: null,
    hintDialog: false,
    hintText: '',
    search: '',
    date: new Date().toISOString(),
    headers_surcharges: [
      { text: 'Dauer', value: 'amount', sortable: false,},
      { text: 'Zulage', value: 'name', sortable: false,},
    ],
    headers_fahrs: [
      { text: 'Dauer', value: 'amount', sortable: false,},
      { text: 'Fahrzeug', value: 'title', sortable: false,},
    ],
    headers_artis: [
      { text: 'Menge', value: 'amount', sortable: false,},
      { text: 'Material', value: 'title', sortable: false,},
    ],
    items_surcharges: [],
    items_fahrs: [],
    items_artis: [],
    modal: false,
    currentBlock: -1,
    focusedEvent: '',
    overview: {
      user_day: {
        soll: 0.0,
        ist: 0.0,
        valence: 0.0,
        has_rufbereitschaft: false,
      },
      time_blocks: [],
      time_surcharges: 0.0,
      ueb_performed: 0.0,
      roundings: 0.0,
      rounding_entries: [],
      rb: "",
      surcharges: [],
    },
    // create data
    createStart: '',
    createEnd: '',
    augrs: [],
    objectMap: {},
    legrs: [],
    learMap: {},
    fehls: [],
    ezs: [],
    fahrs: [],
    artis: [],
    schluessel_mapping: {},
    einzelMapping: {},
    specialCarModule: false,
    presences: [],
  }),
  computed: {
    currentMitaValue() {
      return this.mitasFlat.find(mita => mita.id === this.currentMita);
    },
    editBlock() {
      if (this.currentBlock !== -1) {
        return this.overview.time_blocks[this.currentBlock];
      }
      return null;
    },
    blockedIntervals() {
      let blocks = [];
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if ( i !== this.currentBlock && this.overview.time_blocks[i].type !== 'PAUS') {
          blocks.push({
            startTime: this.overview.time_blocks[i].von,
            endTime: this.overview.time_blocks[i].bis,
          });
        }
      }
      return blocks;
    },
    breaks() {
      let blocks = [];
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if ( i !== this.currentBlock && this.overview.time_blocks[i].type === 'PAUS') {
          blocks.push({
            startTime: this.overview.time_blocks[i].von,
            endTime: this.overview.time_blocks[i].bis,
          });
        }
      }
      return blocks;
    },
    timeBlockSurcharges() {
      return [];
    },
    formatedDate() {
      let date = this.date.split("-").reverse().join(".");
      let dateTime = new Date(this.date);
      let weekday = this.weekdays[dateTime.getDay()];
      return date + " (" + weekday + ")";
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if(!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
    selectedMitaName() {
    let mita = this.mitasFlat.find(mita => mita.id === this.currentMita);
      if (mita) {
        return mita.name;
      }
      return "";
    },
  },
  created() {
    this.showLoader();
    let query = this.$route.query;
    if (query.date) {
      let date = new Date(query.date);
      date = new Date(date.setHours(12)).toISOString();
      this.date = date;
    }
    this.$http.get(
        Server_URL_ZK + '/zk/responsible_users_data'
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {
    onBookAbfeiern() {
      // first get the start time
      let startTime = this.overview.user_time.soll_zeit.split("-")[0];
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].bis > startTime && this.overview.time_blocks[i].type !== 'PAUS') {
          startTime = this.overview.time_blocks[i].bis;
        }
      }
      let pausesToConsider = [];
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].type === 'PAUS' && this.overview.time_blocks[i].von >= startTime) {
          pausesToConsider.push(this.overview.time_blocks[i]);
        }
      }
      let res = this.getBookingSegments(pausesToConsider, startTime, this.overview.user_day.soll-this.overview.user_day.ist);
      let books = [];
      for (let i = 0; i < res.length; i++) {
        let id = getUid();
        books.push({
          id: id,
              legr: "",
              objekt: this.getCurrentMita(this.currentMita).mita_key,
              von: res[i].von,
              bis: res[i].bis,
              std: this.formateHours(this.unformateHours(res[i].bis) - this.unformateHours(res[i].von)),
              menge: 0.0,
              aufisn: this.ueberstunden_abgebaut_lohn.bis_id,
              posnr: "",
              lear: "",
              creator: "",
              created: "",
              grp: "",
              dep: id,
              typ: "FEHL",
              deployed: "",
              hinweis: "",
              tid: "",
        });
      }
      this.onUpdateWork([], books)
    },
    onFehlSelected(fehl) {
      // first get the start time
      let startTime = this.overview.user_time.soll_zeit.split("-")[0];
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].bis > startTime && this.overview.time_blocks[i].type !== 'PAUS') {
          startTime = this.overview.time_blocks[i].bis;
        }
      }
      let pausesToConsider = [];
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].type === 'PAUS' && this.overview.time_blocks[i].von >= startTime) {
          pausesToConsider.push(this.overview.time_blocks[i]);
        }
      }
      let res = this.getBookingSegments(pausesToConsider, startTime, this.overview.user_day.soll-this.overview.user_day.ist);
      let books = [];
      // you cant book more than one day of a fehlzeit at once
      let maxMenge = 1.0;
      // only consider day bookings
      if (fehl.lohn_usage_type === 'PE05') {
        for (let i = 0; i < this.overview.time_blocks.length; i++) {
          if (this.overview.time_blocks[i].work.typ === 'FEHL' && this.overview.time_blocks[i].work.aufisn === fehl.bis_id) {
            maxMenge -= this.overview.time_blocks[i].work.menge;
          }
        }
      }
      for (let i = 0; i < res.length; i++) {
        let id = getUid();
        books.push({
          id: id,
          legr: "",
          objekt: this.getCurrentMita(this.currentMita).mita_key,
          von: res[i].von,
          bis: res[i].bis,
          std: this.formateHours(this.unformateHours(res[i].bis) - this.unformateHours(res[i].von)),
          menge: 0.0,
          aufisn: fehl.bis_id,
          posnr: "",
          lear: "",
          creator: "",
          created: "",
          grp: "",
          dep: id,
          typ: "FEHL",
          deployed: "",
          hinweis: "",
          tid: "",
        });
      }
      this.onUpdateWork([], books)
    },
    getBookingSegments(existingEntries, bookingStartStr, durationHours) {
      // 1. Helper to convert 'HH:mm' to total minutes
      const toMin = (s) => {
        const [h, m] = s.split(':').map(Number);
        return h * 60 + m;
      };

      // 2. Helper to convert minutes back to 'HH:mm'
      const toStr = (m) => {
        const h = Math.floor(m / 60).toString().padStart(2, '0');
        const min = (m % 60).toString().padStart(2, '0');
        return `${h}:${min}`;
      };

      let remainingMins = durationHours * 60;
      let currentPtr = toMin(bookingStartStr);
      const results = [];

      // Sort entries by start time
      const sortedEntries = [...existingEntries].sort((a, b) => toMin(a.von) - toMin(b.bis));

      for (const entry of sortedEntries) {
        const entryStart = toMin(entry.von);
        const entryEnd = toMin(entry.bis);

        // If the current pointer is before the next busy block, there is a gap
        if (currentPtr < entryStart) {
          const gapSize = entryStart - currentPtr;
          const take = Math.min(gapSize, remainingMins);

          results.push({
            von: toStr(currentPtr),
            bis: toStr(currentPtr + take)
          });

          remainingMins -= take;
          if (remainingMins <= 0) return results;
        }

        // Move the pointer to the end of the busy block if we've passed it
        currentPtr = Math.max(currentPtr, entryEnd);
      }

      // 3. If there's still time needed after the last entry
      if (remainingMins > 0) {
        results.push({
          von: toStr(currentPtr),
          bis: toStr(currentPtr + remainingMins)
        });
      }

      return results;
    },
    isMobile(user) {
      for (let i = 0; i < this.presences.length; i++) {
        if (this.presences[i].user.gischl === user.bis_id && this.presences[i].user_day.creator === 'mobile') {
          return true;
        }
      }
      return false;
    },
    getUserColor(user) {
      for (let i = 0; i < this.presences.length; i++) {
        if (this.presences[i].user.gischl === user.bis_id && this.presences[i].ist_zeit > 0) {
          return this.presences[i].ist_zeit >= this.presences[i].soll_zeit ? '#328f33' : '#ff0000'
        }
      }
      return '#000000';
    },
    onNewTime({start, end}) {
      this.createStart = start;
      this.createEnd = end;
      this.onExpand(null, false);
      // wait one tick
      this.$nextTick(() => {
        this.$refs.timeBlockDialog.openDialog();
      });
    },
    openExisting() {
      this.createStart = '';
      this.createEnd = '';
      this.$nextTick(() => {
        this.$refs.timeBlockDialog.openDialog();
      });
    },
    getItemClass(item) {
      return item.id === this.currentExpand ? 'row-focused' : '';
    },
    showHint(item) {
      this.hintText = item.hinweis;
      this.hintDialog = true;
    },
    onExpand(item, scroll = true) {
      if (item === null || this.currentExpand === item.id) {
        this.currentExpand = null;
        this.$refs.user_day_table.expand(item, false)
      } else {
        this.currentExpand = item.id;
        this.$refs.user_day_table.expand(item, true)
      }
      this.currentBlock = -1;
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].id === this.currentExpand) {
          this.currentBlock = i;
          if (!this.overview.time_blocks[i].children || this.overview.time_blocks[i].children.length === 0) {
            this.$refs.user_day_table.expand(item, false)
          }
          break;
        }
      }
      this.selectDay();
      if (this.currentBlock !== -1 && scroll) {
        this.$refs.day_view.scrollTo(this.currentBlock);
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        let selectedMitaId = this.$route.query.user;
        for (let i = 0; i < response.body.migrs.length; i++) {
          this.activeMita.push(null);
        }
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
          if (selectedMitaId && (selectedMitaId === mita.id || selectedMitaId.split("-")[0] === mita.bis_id)) {
            this.currentMita = mita.id;
          }
        }
        this.holliday_lohn = response.body.holliday_lohn;
        this.ueberstunden_abgebaut_lohn = response.body.ueberstunden_abgebaut_lohn;
        this.fehls = response.body.fehlzeiten;
        this.ezs = response.body.ezs;
        this.augrs = response.body.augrs;
        this.objectMap = response.body.aufisn_map;
        this.legrs = response.body.legrs;
        this.learMap = response.body.lear_map;
        this.artis = response.body.artis;
        this.fahrs = response.body.fahrs;
        this.schluessel_mapping = response.body.schluessel_mapping;
        this.einzelMapping = response.body.einzels;
        this.specialCarModule = response.body.special_car_module;

        if (this.currentMita) {
          this.changeMita(this.currentMita);
        }
      } else {
        window.location = Redirect_500;
      }
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    moveDate(direction) {
      let curDate = new Date(new Date(this.date).setHours(12));
      // add or subtract one day based on direction
      let date = new Date(curDate.setDate(curDate.getDate() + direction)).toISOString();
      this.setDate(date);
    },
    setDate(date) {
      this.date = date;
      console.log(this.date)
      this.$nextTick(() => {
        this.changeMita(this.currentMita);
      });
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    sortedItems(migr) {
      return _orderBy(this.mitas[migr], 'name');
    },
    clearSearch () {
      this.search="";
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseError(response) {
      this.hideLoader();
      console.log(response)
      if (response.status === 401) {
        //window.location = Redirect_Login;
      } else {
        //window.location = Redirect_500;
      }
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    changeMita(mitaId) {
      if (mitaId !== undefined) {
        let mita = this.getCurrentMita(this.currentMita);
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/user_day/' + mita.bis_id + "?date=" + this.date.substring(0, 10)
        ).then(this.responseOkGetOverview, this.responseError)
      } else {
        this.currentBlock = -1;
        if (this.currentExpand) {
          this.$refs.user_day_table.expand(this.currentExpand, false);
          this.currentExpand = null;
        }
        this.overview = {
          user_day: {
            soll: 0.0,
            ist: 0.0,
            valence: 0.0,
            has_rufbereitschaft: false,
          },
          time_blocks: [],
          time_surcharges: 0.0,
          ueb_performed: 0.0,
          roundings: 0.0,
          rounding_entries: [],
          rb: "",
          surcharges: [],
        };
        this.selectDay();
      }
    },
    responseOkGetOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.currentBlock = -1;
        if (this.currentExpand) {
          this.$refs.user_day_table.expand(this.currentExpand, false);
          this.currentExpand = null;
        }
        this.overview = response.body;
        this.selectDay();
      } else {
        window.location = Redirect_500;
      }
    },
    getUserPresence() {
      this.$http.get(
          Server_URL_ZK + '/zk/user_presence?date=' + this.date.substring(0, 10)
      ).then(this.responseOkPresence, this.responseError)
    },
    responseOkPresence(response) {
      if (response.status === 200) {
        this.presences = response.body.items;
      } else {
        window.location = Redirect_500;
      }
    },
    onBack() {
      this.$router.go(-1);
    },
    formateHours(hours) {
      return Math.floor(hours) + ":" + ("0" + (hours % 1 * 60)).slice(-2);
    },
    unformateHours(hoursStr) {
      let parts = hoursStr.split(":");
      return parseInt(parts[0]) + (parseInt(parts[1]) / 60);
    },
    roundToDigits (number, digits) {
      const roundTo = Math.pow(10, digits)
      return (Math.round(number * roundTo) / roundTo).toFixed(2)
    },
    selectDay() {
      this.getUserPresence();
      let surs = [];
      let fahrs = [];
      let artis = [];
      let current = this.overview;
      let currentBlock = this.currentBlock !== -1 ? this.overview.time_blocks[this.currentBlock] : undefined;
      for (let i = 0; i < current.rounding_entries.length; i++) {
        if (!currentBlock || (current.rounding_entries[i].von === currentBlock.von && current.rounding_entries[i].bis === currentBlock.bis)) {
          surs.push({
            amount: this.unformateHours(current.rounding_entries[i].std),
            name: "Rundung",
            type: 'PE02'
          });
        }
      }
      for (let i = 0; i < this.overview.surcharges.length; i++) {
            if (!currentBlock || (this.overview.surcharges[i].von === currentBlock.von && this.overview.surcharges[i].bis === currentBlock.bis) || this.overview.surcharges[i].origin === currentBlock.id) {
              surs.push(this.overview.surcharges[i]);
            }
      }
          for (let j = 0; j < current.time_blocks.length; j++) {
            if (this.currentBlock === -1 || this.currentBlock === j) {
              for (let k = 0; k < current.time_blocks[j].children.length; k++) {
                if (current.time_blocks[j].children[k].type === 'FAGE') {
                  fahrs.push(current.time_blocks[j].children[k]);
                } else if (current.time_blocks[j].children[k].type === 'ARTI') {
                  artis.push(current.time_blocks[j].children[k]);
                }
              }
            }
          }
      // add up the surcharges
      let finalSurs = [];
      surs.forEach(sur => {
        let found = false;
        for (let i = 0; i < finalSurs.length; i++) {
          if (finalSurs[i].name === sur.name) {
            finalSurs[i].amount += sur.amount;
            found = true;
            break;
          }
        }
        if (!found) {
          finalSurs.push({
            name: sur.name,
            amount: sur.amount,
            type: sur.type,
          });
        }
      });
      // order by name
      finalSurs = _orderBy(finalSurs, 'name');
      // format amount to hh:mm
      finalSurs.forEach(sur => {
        if (sur.type === 'PE02') {
          sur.amount = this.formateHours(sur.amount) + " Std.";
        } else {
          sur.amount = (this.roundToDigits(sur.amount, 2) + "").replace('.', ',');
        }
      });
      // add up the fahrs
      let finalFahrs = [];
      fahrs.forEach(fahr => {
        let found = false;
        for (let i = 0; i < finalFahrs.length; i++) {
          if (finalFahrs[i].title === fahr.title) {
            finalFahrs[i].amount += this.unformateHours(fahr.std);
            found = true;
            break;
          }
        }
        if (!found) {
          finalFahrs.push({
            title: fahr.title,
            amount: this.unformateHours(fahr.std),
          });
        }
      });
      fahrs = _orderBy(finalFahrs, 'title');
      // format amount to hh:mm
      fahrs.forEach(fahr => {
        fahr.amount = this.formateHours(fahr.amount) + " Std.";
      });
      // add up the artis
      let finalArtis = [];
      artis.forEach(arti => {
        let found = false;
        let amount = parseFloat(arti.std.substring(0, arti.std.indexOf(' ')));
        let type = arti.std.substring(arti.std.indexOf(' ') + 1);
        for (let i = 0; i < finalArtis.length; i++) {
          if (finalArtis[i].title === arti.title) {
            finalArtis[i].amount += amount;
            found = true;
            break;
          }
        }
        if (!found) {
          finalArtis.push({
            title: arti.title,
            amount: amount,
            type: type,
          });
        }
      });
      artis = _orderBy(finalArtis, 'title');
      // format float
      artis.forEach(arti => {
        arti.amount = ((this.roundToDigits(arti.amount, 2) + " ").replace('.', ',')) + arti.type;
      });

      this.items_surcharges = finalSurs;
      this.items_fahrs = finalFahrs;
      this.items_artis = finalArtis;
    },
    onDelete() {
      let deleteIds = [];
      if (this.currentBlock !== -1) {
        deleteIds.push(this.overview.time_blocks[this.currentBlock].work.id);
        for (let i = 0; i < this.overview.time_blocks[this.currentBlock].children.length; i++) {
          deleteIds.push(this.overview.time_blocks[this.currentBlock].children[i].work.id);
        }
        this.onUpdateWork(deleteIds, []);
      }
    },
    onExtendTimeBlock({id, start, end}) {
      let changedWorks = [];
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].id === id) {
          this.overview.time_blocks[i].von = start;
          this.overview.time_blocks[i].bis = end;
          let std = this.formateHours(this.unformateHours(end) - this.unformateHours(start));
          this.overview.time_blocks[i].work.von = start;
          this.overview.time_blocks[i].work.bis = end;
          this.overview.time_blocks[i].work.std = std;
          changedWorks.push(this.overview.time_blocks[i].work);
          for (let j = 0; j < this.overview.time_blocks[i].children.length; j++) {
            if (this.overview.time_blocks[i].children[j].type === 'FAGE' || this.overview.time_blocks[i].children[j].type === 'LOHN') {
              this.overview.time_blocks[i].children[j].work.von = start;
              this.overview.time_blocks[i].children[j].work.bis = end;
              this.overview.time_blocks[i].children[j].work.std = std;
              changedWorks.push(this.overview.time_blocks[i].children[j].work);
            }
          }
          this.onUpdateWork([], changedWorks);
          break;
        }
      }
    },
    saveBlock({blocks, finishTodo}) {
      let deleted = [];
      let changed = []
      for (let j = 0; j < blocks.length; j++) {
        let block = blocks[j];
        changed.push(block.work);
        for (let i = 0; i < block.children.length; i++) {
          changed.push(block.children[i].work);
        }
      }
      if (this.currentBlock !== -1) {
        let currentIds = [];
        currentIds.push(this.overview.time_blocks[this.currentBlock].work.id);
        for (let i = 0; i < this.overview.time_blocks[this.currentBlock].children.length; i++) {
          currentIds.push(this.overview.time_blocks[this.currentBlock].children[i].work.id);
        }
        for (let i = 0; i < currentIds.length; i++) {
          let found = false;
          for (let j = 0; j < changed.length; j++) {
            if (changed[j].id === currentIds[i]) {
              found = true;
              break;
            }
          }
          if (!found) {
            deleted.push(currentIds[i]);
          }
        }
      }
      console.log(changed)
      this.onUpdateWork(deleted, changed);
    },
    onUpdateWork(deleted, changed) {
      let mita = this.getCurrentMita(this.currentMita);
      console.log(this.overview)
      let req = {
        delete_ids: deleted,
        upsert_works: changed
      }
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].id.startsWith('auto_pause') && !req.upsert_works.find(w => w.id === this.overview.time_blocks[i].work.id) && !deleted.includes(this.overview.time_blocks[i].work.id)) {
          req.upsert_works.push(this.overview.time_blocks[i].work);
        }
      }
      let idMap = new Map();
      for (let i = 0; i < req.upsert_works.length; i++) {
        if (req.upsert_works[i].id.startsWith('auto_pause')) {
          if (idMap.has(req.upsert_works[i].id)) {
            req.upsert_works[i].id = idMap.get(req.upsert_works[i].id);
          } else {
            let id = getUid();
            idMap.set(req.upsert_works[i].id, id);
            req.upsert_works[i].id = id;
          }
        }
        if (req.upsert_works[i].dep.startsWith('auto_pause')) {
          if (idMap.has(req.upsert_works[i].dep)) {
            req.upsert_works[i].dep = idMap.get(req.upsert_works[i].dep);
          } else {
            let id = getUid();
            idMap.set(req.upsert_works[i].dep, id);
            req.upsert_works[i].dep  = id;
          }
        }
      }
      if (req.upsert_works.length > 0 && req.upsert_works[0].typ === 'FEHL'
          && this.fehls.find(f => f.bis_id === req.upsert_works[0].aufisn)
          && this.fehls.find(f => f.bis_id === req.upsert_works[0].aufisn).lohn_usage_type === 'PE05') {
        let maxMenge = 1.0;
        const roundAndClip = (x, unit) => {
          const rounded = Math.round(x / unit) * unit;
          // Math.max(0.25, ...) ensures it doesn't go below 0.25
          // Math.min(..., 1.0) ensures it doesn't go above 1.0
          return Math.min(Math.max(rounded, 0.25), 1.0);
        };
        for (let i = 0; i < this.overview.time_blocks.length; i++) {
          if (this.overview.time_blocks[i].work.typ === 'FEHL'
              && this.overview.time_blocks[i].work.aufisn === req.upsert_works[0].aufisn
              && !req.upsert_works.find(w => w.id === this.overview.time_blocks[i].work.id) && !deleted.includes(this.overview.time_blocks[i].work.id)) {
            maxMenge -= this.overview.time_blocks[i].work.menge;
          }
        }
        if (maxMenge < 0) {
          maxMenge = 0
        }
        for (let i = 0; i < req.upsert_works.length; i++) {
          let menge = 0.0;
            let duration = this.unformateHours(req.upsert_works[i].std);
            menge = roundAndClip(duration / this.overview.user_day.soll, 0.25);
            menge = Math.min(menge, maxMenge);
            maxMenge -= menge;
            req.upsert_works[i].menge = menge;
        }
      }
      this.showLoader();
      console.log(req)
      this.$http.post(
          Server_URL_ZK + '/zk/user_day/' + mita.bis_id + "?date=" + this.date.substring(0, 10), req
      ).then(this.responseOkGetOverview, this.responseError)
    },
  }


}
</script>

<style scoped>


::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.undefined {
  background-color: rgb(161, 149, 149) !important;
  border-color: rgb(161, 149, 149) !important;
  color: white;
}

.soll-ist.zero {
  background-color: rgb(255, 185, 0) !important;
  border-color: rgb(255, 185, 0) !important;
  color: white;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

::v-deep .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0 4px 4px -6px rgba(50, 50, 50, 0.75), inset 0 -4px 4px -6px rgba(50, 50, 50, 0.75)
}

::v-deep .v-event-timed:has(> .event-focused) {
  border: 2px solid black !important;
}

::v-deep .row-focused {
  background-color: #b8ccfa !important;
}

</style>
